// extracted by mini-css-extract-plugin
export default {"container":"LegalDocument_container__gpO6a","content":"LegalDocument_content__+C+Nw","lastUpdated":"LegalDocument_lastUpdated__TaHwL"};